export type ProductDiscriminator = "StripeProduct" | "AppleProduct" | "ShopifyProduct";

export enum PlanState {
    NON_SHOPIFY_SUBSCRIPTION = "nonShopifySubscription",
    TRIAL_SUBSCRIPTION_ACTIVE = "trialSubscriptionActive",
    TRIAL_SUBSCRIPTION_EXPIRED = "trialSubscriptionExpired",
    SHOPIFY_SUBSCRIPTION = "shopifySubscription",
    STRIPE_MERCHANT_PLAN = "stripeMerchantPlan",
    LOADING = "loading",
}